module.exports = __webpack_public_path__ + "f150b7d4e546b0cce090cf65c98a08ff.MP3";